import { Selector, State } from "./types";
import { planzoneSettings } from "@planzone/dto";

function createSelector(getState: () => State): Selector {
  return {
    isRetrievePlanzoneSettingsRequestFailure({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRetrievePlanzoneSettingsRequestPending({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRetrievePlanzoneSettingsRequestSuccess({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
    getPlanzoneSettings({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.settings : planzoneSettings;
    },
  };
}

export { createSelector };
